import Image from "next/image";

type AdvantagesCardProps = {
  icon: string;
  title: string;
  text: string;
};

export const AdvantagesCard = ({ icon, title, text }: AdvantagesCardProps) => {
  return (
    <div className="flex flex-col flex-1 gap-[18px] p-6 bg-white rounded-xl border-[1px] justify-left">
      <div>
        <Image
          src={`/content/icons/${icon}.svg`}
          alt={title}
          width={54}
          height={54}
        />
      </div>

      <h3 className="text-xl font-bold lg:text-2xl">{title}</h3>
      <p
        dangerouslySetInnerHTML={{ __html: text }}
        className="mb-auto lg:text-lg"
      ></p>
    </div>
  );
};
